import React, { useState } from 'react';
import { FormattedMessage, useIntl } from "react-intl";
import { Row, Col } from 'reactstrap';

import { StatusService } from '../../services/StatusService';

import Toast from "../../helpers/Toast";

import { GetPossibleStatusByBaseStatus } from "../../models/Status/GetPossibleStatusByBaseStatusDTO";
import  { RoleStatusPermissionsDTO } from "../../models/Status/RoleStatusPermissionsDTO";
import ButtonComponent from '../../components/ButtonComponent';
import TableComponent from "../../components/TableComponent";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import CreateStatusPermission from './CreateStatusPermissions';

type NextPossibleStatusProps = {
    BaseStatus: string,
}

function StatusPermissions(props: NextPossibleStatusProps){
    const statusService = new StatusService();
    const intl = useIntl();
    const [role, setRole] = useState<RoleStatusPermissionsDTO[]>([]);
    const pageSizes: number[] = [5, 15, 30];
    const [pageSize, setPageSize] = useState<number>(pageSizes[0]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [goToPage, setGoToPage] = useState<number>();
    const [pageCount, setPageCount] = useState(1);
    const [isCreatePermissionModalOpen, setIsCreatePermissionModalOpen] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [deleteParams, setDeleteParams] = useState<{ statusId: number; roleId: string } | null>(null);

    const columns = React.useMemo(
        () => [
            {
            Header: <FormattedMessage id="Screens.User.Info.Role" />,
            accessor: "roleName",
                Cell: ({ row }: any) => (
                    <span>{row.original.roleName}</span>
                ),
            },
            {
                Header: "", 
                accessor: "actions",
                Cell: ({ row }: any) => (
                    <ButtonComponent
                    text={intl.formatMessage({ id: "General.Delete" })}
                    onClick={() => handleDialogDelete(row.original.statusId, row.original.roleId)}
                    />
                ),
            },
        ],
        [intl]
    );

    const GetStatusRole = async ( currentPage: number, pageSize: number ) => {
        const data: GetPossibleStatusByBaseStatus = {
          id : String(props.BaseStatus), 
          currentPage : currentPage,
          pageSize : pageSize,
        }

        const role = await statusService.GetPermissionToNavigateStatus(data);

        if (role.success === false || role.items == null) {
          Toast.Show("error", "Não foi possível encontrar os perfis permitidos.");
          return;
        }

        if(role.items.length === 0){
            setRole([]);
        }

        setRole(role.items);
        setPageCount(role.totalPages);
        setPageSize(pageSize);
        setCurrentPage(currentPage);
        setGoToPage(0);
        setIsLoading(false);
    }

    const onNewTaskClick = () => {
        setIsCreatePermissionModalOpen(true);
    };

    const handleCloseCreatePermissionModal = () => {
        setIsCreatePermissionModalOpen(false);
        GetStatusRole(currentPage ?? 1, pageSize ?? 5);
    };

    const handleDialogDelete = (statusId: number, roleId: string) => {
        setDeleteParams({ statusId, roleId });
        setConfirmDelete(true);
    };

    const handleCancelDelete = () => {
        setConfirmDelete(false);
        setDeleteParams(null);
    };

    const handleConfirmDelete = async () => {
        if (deleteParams) {
            const result = await statusService.DeletePermissionEditStatus(deleteParams.statusId, deleteParams.roleId);

            if (result.success) {
                Toast.Show("success", result.message ?? "Permissão apagada com sucesso.");
                GetStatusRole(currentPage, pageSize);
            } else {
                Toast.Show("error", result.message ?? "Erro ao apagar a permissão.");
            }
        }
        setConfirmDelete(false);
        setDeleteParams(null);
    };

    return (
        <Row>
            <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                <Row>
                    <ButtonComponent
                        text={intl.formatMessage({ id: "Screens.Status.Create.Permission" })}
                        onClick={onNewTaskClick}
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                        style={{ minHeight: "37px", minWidth: "100px", marginTop: "25px", marginBottom: "25px" }}
                    />
                </Row>
                <div>
                    <label style={{ margin: "0px", padding: "13px" }}><b><FormattedMessage id="Screens.Status.Info.Role" /></b></label>

                    <TableComponent
                        columns={columns}
                        data={role}
                        goToPage={goToPage}
                        initialPage={currentPage}
                        pageCount={pageCount}
                        initialPageSize={pageSize}
                        pageSizes={pageSizes}
                        manualPagination={true}
                        loading={isLoading}
                        fetchData={GetStatusRole}
                        initialSortBy={[]}
                        disableSortBy={true}
                    />
                </div>
                <Dialog open={isCreatePermissionModalOpen} onClose={() => setIsCreatePermissionModalOpen(false)} fullWidth maxWidth="sm">
                    <DialogTitle>Criar Permissão</DialogTitle>
                    <DialogContent>
                        <CreateStatusPermission baseStatus={props.BaseStatus} onSuccess={handleCloseCreatePermissionModal} onCancel={() => setIsCreatePermissionModalOpen(false)}/>
                    </DialogContent>
                </Dialog>
                <Dialog
                open={confirmDelete}
                onClose={handleCancelDelete}
                fullWidth
                >
                <DialogTitle>
                    {intl.formatMessage({ id:  "Screens.Status.ConfirmDelete.Title"})}
                </DialogTitle>
                <DialogContent>
                    <p>{intl.formatMessage({ id: "Screens.Status.Confirm.Reject"})}</p>
                </DialogContent>
                <div style={{ display: "flex", justifyContent: "flex-end", padding: "16px" }}>
                    <ButtonComponent
                        text={intl.formatMessage({ id: "Common.Buttons.Cancel"})}
                        onClick={handleCancelDelete}
                        style={{ marginRight: "8px" }}
                    />
                    <ButtonComponent
                        text={intl.formatMessage({ id: "General.Delete"})}
                        onClick={handleConfirmDelete}
                    />
                </div>
            </Dialog>
            </Col>
        </Row>
    );
}

export default StatusPermissions;